module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_8003.31994fe1.png";